import React from 'react';
import { MobileTabletScreen, DesktopScreen } from '@sm/webassets';

import DesktopNav from './DesktopNavForIE';
import MobileNav from './MobileNavForIE';

export { TEST_ID as DESKTOP_TEST_ID } from './DesktopNavForIE';
export { TEST_ID as MOBILE_TEST_ID } from './MobileNavForIE';

const NavForIE = props => (
  <>
    <DesktopScreen>
      <DesktopNav {...props} />
    </DesktopScreen>
    <MobileTabletScreen>
      <MobileNav {...props} />
    </MobileTabletScreen>
  </>
);

export default NavForIE;
